<template>
  <el-container class="app-layout" direction="vertical">
    <!-- 顶部导航（使用 Affix，避免遮挡内容） -->
    <el-affix :offset="0">
      <AppHeader />
    </el-affix>

    <!-- 主体 -->
    <el-main class="main-content">
      <div :class="contentWrapperClass">
        <router-view />
      </div>
    </el-main>

    <!-- 页脚 -->
    <AppFooter />

    <!-- 回到顶部 -->
    <el-backtop :right="24" :bottom="32" />
  </el-container>
</template>

<script>
import AppHeader from './AppHeaderEP.vue'
import AppFooter from './AppFooter.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    AppFooter
  },
  setup() {
    const route = useRoute()

    const contentWrapperClass = computed(() => {
      const isFullWidth = Boolean(route.meta?.fullWidth)
      return [
        'content-wrapper',
        isFullWidth ? 'content-wrapper--full' : 'container-responsive'
      ]
    })

    return {
      contentWrapperClass
    }
  }
}
</script>

<style scoped>
.app-layout {
  min-height: 100dvh;
  width: 100%;
  flex-direction: column;
  background: var(--el-bg-color-page);
}

.main-content {
  padding: 24px 0 calc(32px + var(--safe-area-bottom));
}

.content-wrapper {
  min-height: calc(100dvh - 160px);
}

@media (max-width: 768px) {
  .main-content {
    padding: 16px 0 calc(24px + var(--safe-area-bottom));
  }
}
</style>
